import React from 'react';
import Text from '../../../Text/Text.js';
import CheckboxOrRadioGroupContext from './CheckboxOrRadioGroupContext.js';
import classes from './CheckboxOrRadioGroup.module.css.js';
import { CSS_MODULES_FLAG } from './FeatureFlag.js';
import '../../../FeatureFlags/FeatureFlags.js';
import { useFeatureFlag } from '../../../FeatureFlags/useFeatureFlag.js';
import '../../../FeatureFlags/DefaultFeatureFlags.js';
import { clsx } from 'clsx';
import { jsx } from 'react/jsx-runtime';

const CheckboxOrRadioGroupCaption = ({
  className,
  children,
  sx
}) => {
  const {
    disabled,
    captionId
  } = React.useContext(CheckboxOrRadioGroupContext);
  const enabled = useFeatureFlag(CSS_MODULES_FLAG);
  if (enabled) {
    if (sx) {
      return /*#__PURE__*/jsx(Text, {
        className: clsx(className, classes.CheckboxOrRadioGroupCaption),
        id: captionId,
        sx: sx,
        children: children
      });
    }
    return /*#__PURE__*/jsx("span", {
      className: clsx(className, classes.CheckboxOrRadioGroupCaption),
      id: captionId,
      children: children
    });
  }
  return /*#__PURE__*/jsx(Text, {
    color: disabled ? 'fg.muted' : 'fg.subtle',
    fontSize: 1,
    id: captionId,
    sx: sx,
    className: className,
    children: children
  });
};
CheckboxOrRadioGroupCaption.displayName = "CheckboxOrRadioGroupCaption";

export { CheckboxOrRadioGroupCaption as default };
